import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    selectAll(event) {
        const checked = event.target.classList.contains('checked');
        const index = event.target.dataset.colPermission;

        if (checked) {
            event.target.classList.remove('checked');
        } else {
            event.target.classList.add('checked');
        }

        for (const checkbox of this.element.querySelectorAll('[data-col-index="' + index + '"]')) {
            checkbox.checked = !checked;
        }
    }
}
